module.exports = __webpack_public_path__ + "media/images/trophy-8be956a491f46c7d8ec6afcca8824093.svg";